// extracted by mini-css-extract-plugin
module.exports = {"centered":"Register_centered__2rK13"};